import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiPlus, FiZap } from 'react-icons/fi';
import './CustomArtCard.css';

const CustomArtCard = () => {
    return (
        <motion.div
            className="custom-art-card-container"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
        >
            <Link
                to="/customize"
                className="premium-custom-card"
            >
                <div className="card-glimmer"></div>

                <div className="card-main-content">
                    <div className="icon-badge">
                        <FiZap className="zap-icon" />
                    </div>

                    <div className="text-content">
                        <span className="premium-label">Bespoke Selection</span>
                        <h2>Customize Your Own Poster</h2>
                        <p>Turn your personal memories or unique ideas into museum-quality art pieces.</p>
                    </div>

                    <div className="cta-action">
                        <FiPlus />
                        <span>Customize Now</span>
                    </div>
                </div>

                <div className="floating-elements">
                    <div className="f-circle c1"></div>
                    <div className="f-circle c2"></div>
                </div>
            </Link>
        </motion.div>
    );
};

export default CustomArtCard;
